import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'byteConverter',
  standalone: true
})
export class ByteConverterPipe implements PipeTransform {
  transform(value: number, decimals: number = 2): string {
    if (value === 0) return '0 Bytes';
    const k = 1024; // Factor for conversion
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB'];
    const i = Math.floor(Math.log(value) / Math.log(k)); // Determine the size unit
    return parseFloat((value / Math.pow(k, i)).toFixed(decimals)) + ' ' + sizes[i];
  }
}
